// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Tooltip_overlay__3e0QP"};